import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-receiving',
  templateUrl: './pda-receiving.component.html',
  styleUrls: ['./pda-receiving.component.scss']
})
export class PdaReceivingComponent implements OnInit {

  constructor(
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/receiving/pda-receiving.component.ts